<ion-row *ngIf="!categories || doNotShowProductsList">
  <ion-col class="ion-text-center">
    <ion-spinner></ion-spinner>
  </ion-col>
</ion-row>

<app-reservation-products-list
  *ngIf="categories && !doNotShowProductsList"
></app-reservation-products-list>
